import React from "react";
import ReactModal from "reactstrap/lib/Modal";
import ModalHeader from "reactstrap/lib/ModalHeader";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalFooter from "reactstrap/lib/ModalFooter";
import { Button, ButtonProps } from "../buttons";
import styles from './Modal.scss'
import classNames from "classnames";
import { ResponsiveSize } from "../Types";

export interface ModalProps {
    id: string
    title: string
    open: boolean
    onClose: () => any
    onOpened?: () => any
    size?: ResponsiveSize
    rightButtons?: ButtonProps[]
    leftButtons?: ButtonProps[]
    keyboard?: boolean
    backdrop?: boolean | "static" | undefined
    className?: string
}

export const Modal: React.FC<ModalProps> = (props) => {
    return <ReactModal id={props.id} isOpen={props.open} toggle={props.onClose} size={props.size} onOpened={props.onOpened} keyboard={props.keyboard} backdrop={props.backdrop}>
        <ModalHeader className={props.className} toggle={props.onClose}>{props.title}</ModalHeader>
        <ModalBody className={props.className} >
            {props.children}
        </ModalBody>
        {props.leftButtons || props.rightButtons ? <ModalFooter className={props.className} >
            {props.leftButtons && props.leftButtons.map((r, i) => i == props.leftButtons!.length - 1 ?
                <Button key={i} {...r} className={classNames(styles["au-modal-button-push"], r.className)} /> : <Button key={i} {...r} />)}
            {props.rightButtons && props.rightButtons.map((r, i) => <Button key={i} {...r} />)}
        </ModalFooter> : <></>}
    </ReactModal>
}